import {
  always,
  compose,
  defaultTo,
  equals,
  filter,
  isNil,
  map,
  prop,
  when
} from 'ramda';
import { isNilOrEmpty } from '@@serverHelpers/index.mjs';
import { numberIsBetween } from '@@viewHelpers/validations/index.js';

const PAYROLL_VALUES_KEY = 'ENTREPRISE_DEMOGRAPHIE_MASSE_SALARIALE_VALEUR';
const NO_BOUND = -1;
const DEFAULT_MIN = 0;

// Les tables CMS stockent les booléens en chaînes ("true") : on accepte aussi un vrai booléen
const isTrue = compose(equals('true'), String);

// Valeur vide ou non numérique : on retombe sur la valeur de repli
const toBound = (fallback) => (value) => {
  if (isNilOrEmpty(value)) {
    return fallback;
  }

  const number = Number(value);
  return Number.isNaN(number) ? fallback : number;
};

// RG03 : un minimum à -1, vide ou non numérique vaut 0
const toMin = compose(
  when(equals(NO_BOUND), always(DEFAULT_MIN)),
  toBound(DEFAULT_MIN)
);

// Un maximum vide ou non numérique vaut -1 (pas de plafond)
const toMax = toBound(NO_BOUND);

const toPayrollRow = (row) => ({
  code: prop('CODE', row),
  label: prop('NOM', row),
  mandatory: isTrue(prop('OBLIGATOIRE', row)),
  min: toMin(prop('MIN', row)),
  max: toMax(prop('MAX', row))
});

export const getPayrollRows = (middleFeatures) => {
  const rows = defaultTo([], prop(PAYROLL_VALUES_KEY, middleFeatures));

  return compose(
    map(toPayrollRow),
    filter(compose(isTrue, prop('AUTORISE')))
  )(rows);
};

export const buildPayrollRule = (getMiddleText) => (row) => {
  const { min, max, mandatory } = row;

  return numberIsBetween(
    min,
    max,
    getMiddleText('ENTREPRISE_DEMOGRAPHIE_MASSE_SALARIALE_INFO', {
      minPayroll: min,
      maxPayroll: max
    }),
    mandatory
  );
};

// Affichage seul : le state du formulaire garde les chiffres bruts
export const formatAmount = (value) => {
  if (isNil(value) || value === '') {
    return '';
  }

  const number = Number(value);

  return Number.isNaN(number) ? '' : number.toLocaleString('fr-FR');
};
